import { Button, Container, Grid, Paper, TextField, useMediaQuery } from "@mui/material";
import PageTitle from "components/molecules/PageTitle";
import SubTitleCommande from "components/molecules/SubTitleCommande";
import CommandeValidationTable from "components/molecules/tables/CommandeValidationTable";
import CommandeHistory from "components/organisms/CommandeHistory";
import Statut from "constants/Statut";
import type Article from "models/Article";
import type CommandeArticleHistory from "models/CommandeArticleHistory";
import type { User } from "@sdeapps/react-core";
import type { ReactNode } from "react";
import SaveIcon from "@mui/icons-material/Save";
import type Commande from "models/Commande";
import type CommandeArticleFormModel from "models/CommandeArticleFormModel";
import { validationStatutOptions } from "constants/SatutMap";

interface ValidatorCommandeTemplateProps {
  demandeur: User | undefined;
  articlesList: Array<CommandeArticleFormModel>;
  updateCommande: () => Promise<void>;
  isSending: boolean;
  historyCommandes: Array<CommandeArticleHistory>;
  setArticlesList: (arg: Array<CommandeArticleFormModel>) => void;
  articles: Array<Article>;
  commentaire: string;
  setCommentaire: (value: string) => void;
  commande: Commande;
}

function ValidatorCommandeTemplate({
  demandeur,
  articlesList,
  updateCommande,
  isSending,
  historyCommandes,
  setArticlesList,
  articles,
  commentaire,
  setCommentaire,
  commande,
}: Readonly<ValidatorCommandeTemplateProps>): ReactNode {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));

  return (
    <>
      <PageTitle title={demandeur?.displayName ?? commande.demandeurNomComplet ?? "???"}>
        <SubTitleCommande demandeur={demandeur} commande={commande}>
          <Button
            variant="contained"
            disabled={
              isSending ||
              articlesList.some(
                (value) => value.statutArticle == null || value.statutArticle === Statut.EN_ATTENTE
              )
            }
            onClick={() => {
              void updateCommande();
            }}
            startIcon={<SaveIcon />}
            loading={isSending}
            loadingPosition="end">
            Mettre à jour{!isSmallScreen && " la commande"}
          </Button>
        </SubTitleCommande>
      </PageTitle>
      <Container maxWidth={false}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, lg: 7, xl: 8 }}>
            <Paper container component={Grid} variant="outlined" size={12}>
              <Grid container size={12}>
                <CommandeValidationTable
                  articlesList={articlesList}
                  setArticlesList={setArticlesList}
                  catalogue={articles}
                  statutOptions={validationStatutOptions}
                  historyCommandes={historyCommandes}
                />
              </Grid>
              <Grid size={12} sx={{ m: 2 }}>
                <TextField
                  value={commentaire}
                  onChange={(e) => {
                    setCommentaire(e.target.value);
                  }}
                  multiline
                  fullWidth
                  label="Commentaire du Validateur"
                  placeholder="Saisissez votre message ici..."
                />
              </Grid>
            </Paper>
          </Grid>
          <Grid size={{ xs: 12, lg: 5, xl: 4 }}>
            <CommandeHistory historyCommandes={historyCommandes} />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default ValidatorCommandeTemplate;
